<script setup lang="ts">
import { computed } from "vue";

export interface CategoryBlockProps {
  imageUrl: string;
  imageAltText: string;
  heading: string;
  subHeading: string;
  text: string;
  rowIndex: number;
  leftOrRight: string;
  layout: string;
  link?: string;
}

const props = defineProps<{
  categoryBlock: CategoryBlockProps;
}>();

const rowStyle = computed(() => "--itemRow: " + props.categoryBlock.rowIndex);
const layoutClass = computed(
  () => "category-grid__item--" + props.categoryBlock.layout.toLowerCase(),
);
const leftOrRightClass = computed(
  () => "category-grid__item--" + props.categoryBlock.leftOrRight.toLowerCase(),
);
const content = computed(
  () =>
    props.categoryBlock.heading ||
    props.categoryBlock.subHeading ||
    props.categoryBlock.text,
);
const imageContainerElement = computed(() =>
  props.categoryBlock.link ? "a" : "div",
);
</script>

<template>
  <li
    class="category-grid__item"
    :class="[leftOrRightClass, layoutClass]"
    :style="rowStyle"
  >
    <div class="category-block">
      <component
        :is="imageContainerElement"
        :href="props.categoryBlock.link"
        class="category-block__link"
      >
        <div class="category-block__image">
          <img
            v-if="props.categoryBlock.imageUrl"
            :src="props.categoryBlock.imageUrl"
            :alt="props.categoryBlock?.imageAltText"
          />
        </div>
      </component>
      <!-- <div class="category-block__content" v-if="content">
        <h3 class="category-block__heading" v-if="props.categoryBlock.heading">
          {{ props.categoryBlock.heading }}
        </h3>
        <p class="category-block__text" v-if="props.categoryBlock.subHeading">
          {{ props.categoryBlock.subHeading }}
        </p>
        <p class="category-block__text" v-if="props.categoryBlock.text">
          {{ props.categoryBlock.text }}
        </p>
      </div> -->
    </div>
  </li>
</template>
